module.exports = __webpack_public_path__ + "img/makis_pachos.1ec78040.jpg";